/**
 * Created by rastwe on 3/1/2017.
 */

import {applyMiddleware, createStore} from 'redux';
import {authenticationMiddleware, workerMiddleware} from '@ey/voltron-core';

import Env from '../util/env';
import apiMiddleware from '../middlewares/api-middleware';
import ceapDownloadMiddleware from '../middlewares/ceap-download-middleware';
import ceapUserMiddleware from '../middlewares/ceap-user-middleware';
import {composeWithDevTools} from 'redux-devtools-extension/developmentOnly';
import docHelperMiddleware from '../middlewares/docHelper-middleware';
import {hooks} from '../middlewares/upload-middleware-hooks';
import loginContextMiddleware from '../middlewares/loginContext-middleware';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import rootReducer from '../reducers';
import {uploadMiddleware} from '@ey/voltron-doc-upload';
import versionCheck from '../middlewares/version-check';

import envConfig from '@ey/voltron-config';
import {adobeAnalytics} from '@ey/voltron-analytics';

/**
 * Configures and creates a Redux store that includes all reducers and
 * the initial state of the application.
 * The devToolsExtension reference in the compose() call is the Chrome
 * implementation of the Redux development tool. Refer to:
 * https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd?hl=en
 * Note that the reduxImmutableStateInvariant middleware is needed only
 * in dev mode to prevent developers from modifying the state directly.
 * Doing so will produce an error.
 * Thunk is here to use for async operations like Ajax.
 * @param {Object} initialState - The initial state of your application.
 *      Particularly useful for server side rendering.
 * @return {*} A Redux Store instance
 */
export default function configureStore(initialState, config = envConfig) {
	const store = createStore(
		rootReducer,
		initialState,
		// Initiate redux dev tools
		composeWithDevTools(
			applyMiddleware(
				ceapDownloadMiddleware(config.ad),
				ceapUserMiddleware(config.ad),
				loginContextMiddleware(config.ad),
				adobeAnalytics.adobeAnalyticsMiddleware(envConfig.adobeAnalytics),
				authenticationMiddleware(config.ad),
				apiMiddleware(config.ad),
				uploadMiddleware(
					Env,
					{
						// These config options are used by the upchunk library: https://github.com/muxinc/upchunk
						chunkSize: 512, // KB
						retries: 3, // times
						delayBeforeRetry: 5, // seconds
						project: 'ares',
						defaultHookDocumentTypes: [98, 102]
					},
					hooks
				),
				docHelperMiddleware(config.ad),
				//bookmark(config),
				workerMiddleware(config.ad),
				/*unBookmark(config),*/
				versionCheck(config.ad),
				// typeof window !== 'undefined' && reduxImmutableStateInvariant()
			)
		)
	);

	return store;
}
